/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs */

const en_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which sources the assistant may answer from, and who sees what.`)
};

const ar_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من أي المصادر يجوز للمساعد الإجابة ومن يرى ماذا.`)
};

const bn_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাসিস্ট্যান্ট কোন উৎস থেকে উত্তর দিতে পারে আর কে কী দেখে।`)
};

const de_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Quellen der Assistent beantworten darf und wer was sieht.`)
};

const es_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De qué fuentes puede responder el asistente y quién ve qué.`)
};

const fr_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles sources l'assistant peut citer et qui voit quoi.`)
};

const pt_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De que fontes o assistente pode responder e quem vê o quê.`)
};

const zh_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确助手可以引用哪些来源，以及谁能看到什么。`)
};

const tr_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistanın hangi kaynaklardan yanıtlayabileceği ve kimin ne göreceği.`)
};

const ru_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Из каких источников ассистенту можно отвечать и кто что видит.`)
};

const pl_svc_rag_knowledge_assistants_scope_detail5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z jakich źródeł asystent może odpowiadać i kto co widzi.`)
};

/**
* | output |
* | --- |
* | "Which sources the assistant may answer from, and who sees what." |
*
* @param {Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_scope_detail5 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_scope_detail5(inputs)
	return en_svc_rag_knowledge_assistants_scope_detail5(inputs)
});
export { svc_rag_knowledge_assistants_scope_detail5 as "svc_rag-knowledge-assistants_SCOPE_detail" }